import CharacterCount from '@tiptap/extension-character-count'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import { type JSONContent, generateHTML } from '@tiptap/vue-3'
import ImageResize from 'tiptap-extension-resize-image'

export const generateHTMLFromJSON = (content: JSONContent) => {
  const parser = new DOMParser()
  return parser.parseFromString(
    generateHTML(toRaw(content), [
      CharacterCount,
      Color,
      Link,
      TextAlign,
      TextStyle,
      Underline,
      StarterKit,
      ImageResize.configure({
        inline: false,
        allowBase64: false,
        HTMLAttributes: {},
      }),
    ]),
    'text/html',
  )
}
